import { ShieldCheck, TrendingDown, Clock, HeartHandshake } from "lucide-react";

const items = [
  { icon: ShieldCheck, label: "50,000+", sub: "Loans facilitated" },
  { icon: TrendingDown, label: "₹42,800", sub: "Avg saving per loan" },
  { icon: Clock, label: "< 24 hrs", sub: "Avg disbursal time" },
  { icon: HeartHandshake, label: "15+", sub: "Banks & NBFC partners" },
];

export const TrustSection = () => (
  <section className="py-14 bg-white border-y border-slate-200">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-6 lg:gap-8">
        {items.map(({ icon: Icon, label, sub }, i) => (
          <div key={i} className="flex items-center gap-4">
            <div className="w-12 h-12 rounded-xl bg-emerald-50 border border-emerald-100 text-emerald-600 flex items-center justify-center flex-shrink-0">
              <Icon className="w-5 h-5" />
            </div>
            <div>
              <div className="font-display font-semibold text-2xl text-slate-900 leading-none">{label}</div>
              <div className="text-xs text-slate-500 mt-1 font-medium">{sub}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);
